import Vue from 'vue';
// import axios from "axios";

// Other Plugin
import BootstrapVue from 'bootstrap-vue';

// import "bootstrap/dist/css/bootstrap.css";
import 'bootstrap-vue/dist/bootstrap-vue.css';
/* ---------------- Font-Awesome ----------------*/
import 'font-awesome/css/font-awesome.css';
import '@/assets/css/main.css';

/* ---------------- VUE SELECT ----------------*/
import vSelect from 'vue-select';
Vue.component('v-select', vSelect);
import 'vue-select/dist/vue-select.css';

import { CoolSelectPlugin } from 'vue-cool-select';
import 'vue-cool-select/dist/themes/bootstrap.css';
Vue.use(CoolSelectPlugin);

// vue toggle Button
import ToggleButton from 'vue-js-toggle-button';
Vue.use(ToggleButton);

/* ---------------- VUE Plus-Minus Input ----------------*/
import VueNumberInput from '@chenfengyuan/vue-number-input';
Vue.component(VueNumberInput.name, VueNumberInput);

import Paginate from 'vuejs-paginate';
Vue.component('paginate', Paginate);

import VuePaginateScroll from 'vue-paginate-scroll';
Vue.component('vue-paginate-scroll', VuePaginateScroll);

/* ---------------- Stylish Scroll Bar ----------------*/
// import vuescroll from "vuescroll";
// Vue.use(vuescroll, {
//   ops: {},
//   name: "myScroll",
// });
/* ---------------- Loading Overlay ----------------*/
// import Loading from "vue-loading-overlay";
// import "vue-loading-overlay/dist/vue-loading.css";
// Vue.use(Loading);
/* ---------------- Vue-Split - for Resizable Grid ----------------*/
import VueSplit from 'vue-split-panel';
Vue.use(VueSplit);

/* ---------------- barCodeScanner ----------------*/
import VueBarcodeScanner from 'vue-barcode-scanner';
// let options = {
// sound: true, // default is false
// soundSrc: "/static/sound.wav", // default is blank
// sensitivity: 300, // default is 100
// requiredAttr: true, // default is false
// controlSequenceKeys: ["NumLock", "Clear"], // default is null
// callbackAfterTimeout: true, // default is false
// };
Vue.use(VueBarcodeScanner);

import App from './App';
import router from './router';
import store from './store';

import axios from '@/plugins/axios.js';
import '@/plugins/vuelidate.js';

Vue.use(require('vue-shortkey'));

Vue.use(BootstrapVue);
// Vue Print
import VueHtmlToPaper from 'vue-html-to-paper';
const options = {
  name: '_blank',
  specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
  ],
};
Vue.use(VueHtmlToPaper, options);
// Vue Glide - corousel
import VueGlide from 'vue-glide-js';
import 'vue-glide-js/dist/vue-glide.css';

Vue.use(VueGlide);

// Vue.http = Vue.prototype.$http = axios;
Vue.axios = Vue.prototype.$axios = axios;
Vue.config.productionTip = false;

// Filters
import '@/utils/filters';

import VueHotkey from 'v-hotkey';

Vue.use(VueHotkey);

// Vue-Mask for Input Fields
const VueInputMask = require('vue-inputmask').default;
Vue.use(VueInputMask);

/* eslint-disable no-new */
new Vue({
  components: { App },
  router,
  store,
  template: '<App/>',
}).$mount('#app');
